import { Routes } from '@angular/router';
import { rootRoutes } from './routes';

export const environment = {
  production: false,
  mock: false,
  noticesUrl: './assets/notices.json',
};

const debugRoutes: Routes = [
  // 必要があればここにデバッグ用のRouteを追加する
];

export const routes: Routes = [...rootRoutes, ...debugRoutes];
